/**
 * 超级管理员权限
 */
const Manager = [
	{
		title: '主页',
		key: 'Home',
		icon: 'h-icon-home'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-paper-stack',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm',
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			},
			{
				title: '凭证明细',
				key: 'VoucherList'
			},
			{
				title: '分摊医美费用',
				key: 'FenPeiFeiYong'
			},
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-book',
		condition: (user, accountSet) => {
			return accountSet && accountSet.companyName && !accountSet.companyName.includes('同步');
		},
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '科目汇总',
				key: 'SubjectSummary'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},
			{
				title: '核算科目明细账',
				key: 'AuxiliarySubjectDetail'
			},
			{
				title: '核算科目余额',
				key: 'AuxiliarySubjectBalance'
			},
			// {
			// 	title: '资产负债表',
			// 	key: 'ZiChanFuZhai'
			// },
			{
				title: '资产负债表',
				key: 'XinZiChanFuZhai'
			},

		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: 'icon-bar-graph-2',
		condition: (user, accountSet) => {
			return accountSet && accountSet.companyName && !accountSet.companyName.includes('同步');
		},
		children: [
			{
				title: '管理部门',
				key: 'Gigalumen'
			},
			{
				title: '经营部门',
				key: 'Aggrandising'
			},

			{
				title: '管理存款',
				key: 'QzGuanLick'
			},
			{
				title: '管理现金',
				key: 'QzGuanLixj'
			},
			{
				title: '经营存款',
				key: 'QzJingYingck'
			},
			{
				title: '经营现金',
				key: 'QzJingYingxj'
			},
			// {
			// 	title: '资产负债',
			// 	key: 'BaoCunZiChanFuZhai'
			// },
			{
				title: '资产负债',
				key: 'HuiZiChanFuZhai'
			},
			{
				title: '城市经理',
				key: 'CityManagerList'
			},
		]
	},
	{
		title: '同步报表',
		key: 'TongBuList',
		icon: 'icon-bar-graph',
		children: [
			{
				title: '同步管理',
				key: 'TbGuanLi',
				condition: (user, accountSet) => {
					return accountSet && accountSet.companyName && !accountSet.companyName.includes('同步');
				}
			},
			{
				title: '同步经营',
				key: 'TbJingYing',
				condition: (user, accountSet) => {
					return accountSet && accountSet.companyName && !accountSet.companyName.includes('同步');
				}
			},
			{
				title: '预测管理',
				key: 'YcGuanLi',
				condition: (user, accountSet) => {
					return accountSet && accountSet.companyName && accountSet.companyName.includes('同步');
				}
			},
			{
				title: '预测经营',
				key: 'YcJingYing',
				condition: (user, accountSet) => {
					return accountSet && accountSet.companyName && accountSet.companyName.includes('同步');
				}
			},
		]
	},
	{
		title: '资产',
		key: 'Assets',
		icon: 'icon-box',
		condition: (user, accountSet) => {
			return accountSet && accountSet.companyName && !accountSet.companyName.includes('同步');
		},
		children: [
			{
				title: '资产类别',
				key: 'AssetClass'
			},
			{
				title: '资产管理',
				key: 'FixedAssets'
			},

			{
				title: '计提折旧',
				key: 'AccrueDepreciation'
			},
			{
				title: '调出明细',
				key: 'AssetDetails'
			},
		]
	},
	{
		title: '结转',
		key: 'CheckList',
		icon: 'h-icon-complete',
	},

	{
		title: '设置',
		key: 'Setting',
		icon: 'h-icon-setting',
		children: [
			{
				title: '账套',
				key: 'Account'
			},
			{
				title: '科目',
				key: 'Subject'
			},
			{
				title: '初始余额',
				key: 'Initial'
			},
			{
				title: '币别',
				key: 'Currency'
			},
			{
				title: '凭证字',
				key: 'VoucherWord'
			},
			{
				title: '辅助核算',
				key: 'AccountingCategory'
			},
			// {
			// 	title: '凭证模板',
			// 	key: 'template'
			// },
			// {
			// 	title: '凭证模板',
			// 	key: 'TemplateManager'
			// },
			// {
			// 	title: '凭证模板',
			// 	key: 'TemplateManager'
			// },
			{
				title: '权限设置',
				key: 'PermissionSetting'
			}

		]
	},
	// {
	// 	title: '模版',
	// 	key: 'Template',
	// 	icon: 'h-icon-lock',
	// 	children: [
	// 		{
	// 			title: '模板管理',
	// 			key: 'TemplateManager'
	// 		},
	//
	//
	// 	]
	// }
];
/**
 * 制单权限
 */
const Making = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '新增凭证',
				key: 'VoucherForm'
			},
			{
				title: '凭证列表',
				key: 'Voucher'
			}
		]
	},
	{
		title: '结转',
		key: 'CheckList',
		icon: 'icon-disc',
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '科目汇总',
				key: 'SubjectSummary'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			},

		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: 'icon-bar-graph-2'
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		]
	}
];
/**
 * 查看权限
 */
const View = [
	{
		title: '主页',
		key: 'Home',
		icon: 'icon-monitor'
	},
	{
		title: '凭证',
		key: 'vouchers',
		icon: 'icon-grid-2',
		children: [
			{
				title: '凭证列表',
				key: 'Voucher'
			}
		]
	},
	{
		title: '帐薄',
		key: 'AccountBooks',
		icon: 'icon-paper',
		children: [
			{
				title: '明细账',
				key: 'DetailedAccounts'
			},
			{
				title: '总账',
				key: 'GeneralLedger'
			},
			{
				title: '科目余额',
				key: 'SubjectBalance'
			},
			{
				title: '科目汇总',
				key: 'SubjectSummary'
			},
			{
				title: '核算项目明细账',
				key: 'AuxiliaryAccountingDetail'
			},
			{
				title: '核算项目余额',
				key: 'AuxiliaryAccountingBalance'
			}
		]
	},
	{
		title: '报表',
		key: 'ReportList',
		icon: 'icon-bar-graph-2'
	},
	{
		title: '设置',
		key: 'Setting',
		icon: 'icon-cog',
		children: [
			{
				title: '账套',
				key: 'Account'
			}
		]
	}
];
/**
 * 不同权限等级对应的菜单配置。
 * 用于根据用户权限显示相应的菜单。
 */
export default {
	// 权限管理
	Manager,
	// 制单
	Making,
	// 查看
	View
};
